// className package simplified port
export const getClassName = (...args) => {
    let className = "";
    args.forEach((arg) => {
        switch (typeof arg) {
            case "string":
                className += ` ${arg}`;
                break;
            case "undefined":
                break;
            default:
                if (arg !== null && typeof arg === "object") {
                    const objClassName = getClassNameFromObject(arg);
                    if (objClassName) {
                        className += ` ${objClassName}`;
                    }
                }
                break;
        }
    });
    return className.trim();
};
export const getClassNameFromObject = (obj) => {
    let className = "";
    Object.keys(obj).forEach((key) => {
        if (obj[key]) {
            className += ` ${key}`;
        }
    });
    return className.trim();
};
//# sourceMappingURL=classNames.js.map